// server
export const SERVER_EXTENSIONS_SECTION_TEST_ID = 'server-extensions-section';
export const SERVER_EXTENSIONS_ENABLED_TEST_ID = 'server-enable-extensions-checkbox';
export const SERVER_EXTENSIONS_LEARN_MORE_LINK_TEST_ID = 'server-extensions-learn-more-link';
export const BLOCK_URL_INPUT_PREFIX_TEST_ID = 'block-url-input-';
export const DELETE_BLOCK_URL_BUTTON_PREFIX_TEST_ID = 'delete-block-url-button-';
export const ADD_BLOCK_URL_BUTTON_TEST_ID = 'add-block-url-button';
export const ADD_BLOCK_URL_TOOLTIP_TEST_ID = 'add-block-url-tooltip';
export const BLOCKLIST_EMPTY_TEST_ID = 'blocklist-empty';

// site
export const SITE_EXTENSIONS_SECTION_TEST_ID = 'site-extensions-section';
export const SANDBOXED_EXTENSIONS_ENABLED_TEST_ID = 'site-enable-sandboxed-extensions-checkbox';
export const TRUSTED_EXTENSIONS_ENABLED_TEST_ID = 'site-enable-trusted-extensions-checkbox';
export const INCLUDE_SANDBOXED_EXTENSIONS_TEST_ID = 'site-include-sandboxed-extensions-checkbox';
export const INCLUDE_TABLEAU_BUILT_EXTENSIONS_TEST_ID = 'site-include-tableau-built-extensions-checkbox';
export const INCLUDE_PARTNER_BUILT_EXTENSIONS_TEST_ID = 'site-include-partner-built-extensions-checkbox';
export const SITE_EXTENSIONS_ENABLED_TEST_ID = 'site-enable-extensions-checkbox';
export const SITE_EXTENSIONS_LEARN_MORE_LINK_TEST_ID = 'site-extensions-learn-more-link';
export const SAFE_URL_INPUT_PREFIX_TEST_ID = 'safe-url-input-';
export const ADD_SAFE_URL_BUTTON_TEST_ID = 'add-safe-url-button';
export const ADD_SAFE_URL_TOOLTIP_TEST_ID = 'add-safe-url-tooltip';
export const FULL_DATA_PREFIX_TEST_ID = 'full-data-';
export const FULL_DATA_TOOLTIP_TEST_ID = 'full-data-tooltip';
export const USER_PROMPT_PREFIX_TEST_ID = 'user-prompt-';
export const USER_PROMPT_TOOLTIP_TEST_ID = 'user-prompt-tooltip';
export const DELETE_SAFE_URL_BUTTON_PREFIX_TEST_ID = 'delete-safe-url-button-';
export const SAFELIST_EMPTY_TEST_ID = 'safelist-empty';
export const EXTENSIONS_DISABLED_WARNING_TEST_ID = 'extensions-disabled-warning-text';
